import { Link } from "react-router-dom";
import { cn } from "@/shared/lib/utils";
import logo from "@/assets/imgs/aspargus_logo.svg";
import smallLogo from "@/assets/imgs/small-logo.svg";

interface SidebarLogoProps {
  isOpen: boolean;
}

export function SidebarLogo({ isOpen }: SidebarLogoProps) {
  return (
    <Link
      to="/dashboard"
      className={cn(
        "flex items-center gap-3 transition-all duration-300",
        !isOpen && "justify-center"
      )}
    >
      {/* Logo Image - Always visible */}
      {!isOpen && (
        <div className="relative w-10 h-10 flex-shrink-0">
          {/* Placeholder for logo image */}
          <img
            src={smallLogo}
            alt="ASPARAGUS"
            className="w-full h-full object-contain"
          />
        </div>
      )}

      {/* Company Name - Only visible when open */}
      {isOpen && (
        <div className="flex flex-col overflow-hidden">
          <img
            src={logo}
            alt="ASPARAGUS"
            className="w-full h-full object-contain"
          />
        </div>
      )}
    </Link>
  );
}
